var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"right-block__timer"},[_vm._v(_vm._s(_setup.timerText)+"\n    "),_c('span',{staticClass:"right-block__timer-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }